module.exports = __webpack_public_path__ + "static/media/logo.e17a98c1.svg";